module.exports = __webpack_public_path__ + "img/home.8a150058.svg";